import { observer } from 'mobx-react';
import { FC, ReactElement, memo } from 'react';
import { MealItemMdfExclModalModifier } from '../../components/MealItemMdfExclModalModifier/MealItemMdfExclModalModifier';
import { mealItemMdfExclModalStore } from '../../store/MealItemMdfExclModalStore';
import { TOOLTIP_DURATION, TOOLTIP_POSITION } from '~/view/components/Controls/CustomTooltip/CustomTooltip';
import Text from '~/view/components/Text/Text';

export const MealItemMdfExclModalModifiers: FC = memo(
  observer((): ReactElement | null => {
    if (!mealItemMdfExclModalStore.modifiers.length) return null;

    return (
      <div className="d-flex flex-column gap-40">
        <Text
          type="section-header"
          text="cm_config_page_show_modifiers_block_hdr"
          tooltip={{
            message: 'cm_config_page_show_modifiers_block_hdr_infotip',
            position: TOOLTIP_POSITION.PORTAL,
            duration: TOOLTIP_DURATION.EXTRA_LARGE,
            maxWidth: 476,
          }}
        />

        <div className="d-flex flex-column gap-20">
          {mealItemMdfExclModalStore.modifiers.map((modifier) => (
            <MealItemMdfExclModalModifier key={modifier.id} modifier={modifier} />
          ))}
        </div>
      </div>
    );
  })
);
